export default __webpack_public_path__ + "static/media/communityStandardBanner.86031631.png";